import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 21.325q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.813Q2.001 12.026 2 9.15 2 6.8 3.575 5.225T7.5 3.65q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575T22 9.15q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125M11.05 7.75q-.725-1.025-1.55-1.562t-2-.538q-1.5 0-2.5 1c-1 1-1 1.5-1 2.5q0 1.3.925 2.762a19 19 0 0 0 2.213 2.838 38 38 0 0 0 2.65 2.575Q11.15 18.525 12 19.3a180 180 0 0 1 2.213-1.975q1.362-1.2 2.65-2.575a19 19 0 0 0 2.212-2.838Q20 10.45 20 9.15q0-1.5-1-2.5c-1-1-1.5-1-2.5-1q-1.175 0-2 .538-.825.537-1.55 1.562a1.14 1.14 0 0 1-.95.5 1.14 1.14 0 0 1-.95-.5" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }